// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as Card from "./Card.res.js";
import * as Group from "./Group.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as LayoutPanelHeading from "./LayoutPanelHeading.res.js";

function TableLayoutPanel(props) {
  return JsxRuntime.jsxs(Group.make, {
    children: [
      JsxRuntime.jsx(LayoutPanelHeading.make, {
        title: props.title,
        description: props.description
      }),
      JsxRuntime.jsx(Card.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: props.children,
          spaceTop: "xxsmall",
          spaceBottom: "xlarge"
        }),
        variation: "unset",
        grow: true
      })
    ],
    grid: [
      "25%",
      "75%"
    ],
    wrap: false
  });
}

let make = React.memo(TableLayoutPanel);

export {
  make,
}
/* make Not a pure module */
